import { MapWorkspace } from "./map-module";
import { CONFIG, HIGHLIGHT_LAYER_ID } from "./rskom/config";
import { ReportCard } from "./rskom/report/ReportCard";

import "./App.css";

export function App() {
  return (
    <MapWorkspace
      className="rskom-app"
      ngwUrl={CONFIG.ngwUrl}
      auth={CONFIG.auth}
      webmapId={CONFIG.webmapId}
      webmapLayerId="rskom-webmap"
      hiddenLayerIds={CONFIG.hiddenLayerIds}
      searchResourceId={CONFIG.searchResourceId}
      identificationHighlightLayerId={HIGHLIGHT_LAYER_ID}
      sidebarFooter={(toolState) => <ReportCard {...toolState} />}
    />
  );
}
